import './helpers.mjs';
import './config.mjs';
import { b as registerComponent, u as use } from './plugins-9401a4a3.mjs';
import './Icon-33c4eb50.mjs';
import './FormElementMixin-8a82acd9.mjs';
import { _ as __vue_component__ } from './Select-504292c7.mjs';
export { _ as OSelect } from './Select-504292c7.mjs';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
